import { AudienceComponent } from "./components/audience/audienceComponent";
import { ContentComponent } from "./components/contenido/contentComponent";


export const configFile = [
    {
        tab: 'tab-1',
        tag: 'span',
        title: 'Contenido de la notificación',
        Contents: ContentComponent,
    },
    {
        tab: 'tab-2',
        tag: 'span',
        title: 'Selección de audiencia',
        Contents: AudienceComponent,
    }
];

